/**
 * API service for User Statistics
 */
import { apiCall } from '../../services/apiUtil';

export const userStatsAPI = {
  getOverallStats: async (userId) => {
    return apiCall(`/users/${userId}/stats/overall`);
  },

  getSportStats: async (userId, sportName) => {
    return apiCall(`/users/${userId}/stats/${sportName}`);
  }
};
